export default __webpack_public_path__ + "media/zurb/img/work/wtsbooks/wtsbooks-thumbnail-ab83de0912470df4db805a8add79e731.png";